import { createSlice } from '@reduxjs/toolkit';

const navigation = createSlice({
  name: 'navigation',
  initialState: {
    scrollToSectionId: null,
  },
  reducers: {
    updateScrollToSectionId: (state, action) => {
      state.scrollToSectionId = action.payload;
    },
  },
});

export const { updateScrollToSectionId } = navigation.actions;
export default navigation.reducer;